// extracted by mini-css-extract-plugin
export default {"currencyModal":"currency_currencyModal__cKyug"};